import { render } from "./Focus.vue?vue&type=template&id=0c82f06d&scoped=true"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"

import "./Focus.vue?vue&type=style&index=0&id=0c82f06d&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c82f06d"]])

export default __exports__